import { render, staticRenderFns } from "./DocumentosCompraDiretaVirtualizada.vue?vue&type=template&id=113943c9"
import script from "./DocumentosCompraDiretaVirtualizada.vue?vue&type=script&lang=js"
export * from "./DocumentosCompraDiretaVirtualizada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports